import $ from "jquery";
import { setResponsiveImage, getImageByContentId } from "#scripts/images";
import { getNews, setNewsList } from "#scripts/news";
import { createNanoId, truncateWithElipsis } from "#scripts/general_functions";
import language from "#scripts/translation";

export const newslistFront = (maxItems, moduleTitle, moduleMoreText) => {
	let more = "";
	let content = "";

	getNews(maxItems, 0, (data) => {
		let news = [];

		if (data.totalCount > 0) {
			data.listOfContent.forEach((item, index) => {
				if (index === Number.parseInt(maxItems)) {
					return;
				}
				const meta = JSON.parse(decodeURIComponent(item.metaObject));

				if (
					meta.imageContentId &&
					window.serverdata.configMeta.aim.showNewsImages
				) {
					const newsGuid = createNanoId();
					let image = "";

					image = `<img src='' id='news__${newsGuid}' class="news__image" desc="${meta.imageDescription}" alt="${meta.imageDescription}">`;
					getImageByContentId(meta.imageContentId, (img) => {
						$(`#news__${newsGuid}`).attr({
							"data-src": img.url,
							src: "/images/transparent.png",
							"data-imagemode": "fill",
						});
						if (
							img.imageHotspotX !== undefined &&
							img.imageHotspotY !== undefined
						) {
							$(`#news__${newsGuid}`).attr({
								"data-imagehotspot": `${img.imageHotspotX},${img.imageHotspotY}`,
							});
						}
						setResponsiveImage($(`#news__${newsGuid}`));
					});

					news.push(`
                  <div class="news__item">
                    <a href="/nyhet/${item.contentId}">
                      <div class="news__image_container">
                        ${image}
                      </div>
                      <div class="news__item__content">
                        <span class="news__item__title">${item.title}</span>
                        <p class="news__item__intro">${truncateWithElipsis(
													item.intro,
													170,
												)}</p>        
                      </div>
                    </a>
                  </div>`);
				} else {
					news.push(`
                    <div class="news__item">
                      <div class="news__item__content">
                        <a href="/nyhet/${item.contentId}" class="news__item__title">
                            ${item.title}
                            <p class="news__item__intro">${truncateWithElipsis(
															item.intro,
															170,
														)}</p>
                        </a>
                      </div>
                    </div>`);
				}
			});
			news = news.join("");

			if (data.totalCount > maxItems) {
				more = `<a href="/liste/nyheter" class="news__more__link">${
					moduleMoreText !== "" ? moduleMoreText : language("NEWS_SEEALL")
				} <span class="material-icons-outlined notranslate news__more__icon">&#xE5C8;</span></a>`;
			}

			content = `
            <div class="news">
                <div class="container p-0">
                    <div class="row">
                        <div class="col"><h2 class="news__title">${
													moduleTitle !== ""
														? moduleTitle
														: language("START_NEWSHEADER")
												}</h2></div>
                    </div>
                    <div class="row news__list">
                        ${news}
                    </div>
                    <div class="row">
                        <div class="col text-right">
                            <div class="news__more__container">
                                ${more}
                            </div>
                        </div>
                    </div>
                </div>
            </div>`;

			$("#newslist__frontpage").html(content);
		}
	});

	return '<div id="newslist__frontpage"></div>';
};

export const newspage = () => {
	const list = setNewsList();
	return `
        <div class="newslist__page" id="newslistcontainer">
            ${list}
        </div>`;
};

// const XsetNewsList = (from, loadNum) => {
//   // const breadcrumbHtml = breadcrumb();
//   loadNum = loadNum || 10;
//   from = from || 0;

//   getNews(loadNum, from, function (result) {
//     const availablenews = result.totalCount;
//     const to = loadNum + from;
//     let newsList = [];

//     // $.each(result.listOfContent, function (a, b) {
//     result.listOfContent.forEach((item, index) => {
//       if (index === parseInt(loadNum)) { return; }
//       const date = new Date(item.firstCreated);
//       const pDate = ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear();
//       const meta = JSON.parse(decodeURIComponent(item.metaObject));
//       let img = '';
//       const width = 'col-sm-9';

//       if (meta.imageContentId !== undefined && meta.imageContentId.length > 0) {
//         const imgId = createNanoId();
//         img = `
//                     <div class="col-sm-3 image__container">
//                         <img src="" alt="" class="article__introimage" id="${imgId}" >
//                     </div>`;

//         getImageByContentId(meta.imageContentId, (img) => {
//           if (img.url !== undefined && img.url.length > 0) {
//             $(`#${imgId}`).attr('src', img.url);
//           }
//         });
//       }

//       newsList.push(`
//                 <div class="newslist__item">
//                     <div class="row">
//                         <a href = "/article/${item.contentId}" class="newslist__link" >
//                             ${img}
//                             <div class="${width}">
//                                 <div class="newslist__content">
//                                     <h2 class="newslist__header">
//                                         ${item.title}
//                                     </h2>
//                                     <p class="newslist__intro">${b.intro}</p>
//                                     <div class="newslist__date">${pDate}</div>
//                                 </div>
//                             </div>
//                         </a>
//                     </div>
//                 </div>`);
//     });

//     // $("#currentPageBreadcrumb").text(document.title);
//     newsList = newsList.join('');

//     $('.newslist__list').append(newsList);
//     const newslistHeader = `
//             <div class="row">
//                 <div class="col mt-5">
//                     <p>
//                         Viser nyhet ${from + 1} til ${availablenews > to ? to : availablenews} av ${availablenews}
//                     </p>
//                 </div>
//             </div>`;

//     $('.newslist__info').html(newslistHeader);
//     if (availablenews > loadNum) {
//       const pages = Math.ceil(availablenews / loadNum);
//       let pageslinks = createPaging(pages, loadNum, from);

//       pageslinks = pageslinks.join('');
//       const newslistFooter = `
//                 <div class="row">
//                     <div class="col mt-5">
//                         <nav aria-label="Bla i sider">
//                           <ul class="pagination  pagination-lg">
//                             ${pageslinks}
//                           </ul>
//                         </nav>
//                     </div>
//                 </div>`;

//       $('.newslist__footer').html(newslistFooter);
//     }
//   });

//   $('body').off('click', '.news__page__links');
//   $('body').on('click', '.news__page__links', function (e) {
//     e.preventDefault();
//     const num = $(this).data('from');
//     setNewsList(parseInt(num));
//     // $(window).scrollTo(0);
//   });

//   const listcontainer = `
//         <div class="container">
//             <div class="row">
//                 <div class="newslist col">
//                     <h1 class="page__header">Nyheter</h1>
//                     <div class="newslist__info"></div>
//                     <div class="newslist__list"></div>
//                     <div class="newslist__footer"></div>
//                 </div>
//             </div>
//         </div>`;

//   $('#newslistcontainer').html(listcontainer);
//   return listcontainer;
// };

// const XcreatePaging = (pages, loadNum, from) => {
//   const pageslinks = [];
//   let i = 0;

//   for (i = 0; i < pages; i++) {
//     if (pages > 15) {
//       if (!(i * loadNum < from - 4)) {
//         pageslinks.push(`<li class="page-item"><a class="page-link news__page__links " href="#" data-from="${i * loadNum}" >${i + 1}</a></li>`);
//       }
//       if (i === from + 4) {
//         pageslinks.push('<li>...</li>');
//       }
//     } else {
//       pageslinks.push(`
//                   <li class="page-item ${i * loadNum === from ? 'disabled' : ''}"><a class="page-link news__page__links " href="#" data-from="${i * loadNum}" >${i + 1}</a></li>`);
//     }
//   }
//   return pageslinks;
// };
